export default {
    getAllCharities (state) {
        return state.charities
    },
    getCharity (state) {
        return state.charity
    },
    getSelectedCharity (state) {
        return state.selectedCharity
    }
}



// WEBPACK FOOTER //
// ./src/store/charities/getters.js